import React from 'react';
import Grid from '@material-ui/core/Grid';

import NotificationMessage from './utils/NotificationMessage';
import PropTypes from 'prop-types';


const Loader = ({variant, message}) => (
    <Grid container justify='center'>
        <NotificationMessage variant={variant} message={message} />
    </Grid>
);

Loader.propTypes = {
    message: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(['error', 'info']).isRequired
};

export default Loader;



// WEBPACK FOOTER //
// ./src/Loader.jsx